import titleize from '../../utils/titleize';
import { Fragment } from 'preact';
import translations, { DEFAULT_LANG } from '../../translations/i18n';
import widgetConfig from '../../../config';

const getHybridSearchMeta = place => place?.meta?.hybrid_search || place?.meta?.hybridSearch || {};

export const isCityAllTerminalsPlace = place => {
  const hybridSearchMeta = getHybridSearchMeta(place);
  return Boolean(hybridSearchMeta?.all_terminals || hybridSearchMeta?.allTerminals);
};

export function getAllTerminalsLabel(lang = widgetConfig.i18nLng) {
  return (
    translations[lang]?.placeholder?.all_terminals ||
    translations[DEFAULT_LANG]?.placeholder?.all_terminals ||
    'All terminals'
  );
}

export function formatCityAllTerminalsDisplay(place, lang) {
  const cityName = place.city_name || place.cityName || place.display;
  return `${titleize(cityName)}, ${getAllTerminalsLabel(lang)}`;
}

export function formatCityDisplay(isPackagesSearch, place, lang) {
  if (isCityAllTerminalsPlace(place)) return formatCityAllTerminalsDisplay(place, lang);

  const cityDisplay = isPackagesSearch ? '' : `, ${titleize(place.display)}`;
  return `${titleize(place.city_name)}${cityDisplay}`;
}

export function formatStateDisplay(place) {
  return titleize(`${place.display}, ${place.state}`);
}

export function formatTerminalCityDisplay(place) {
  return titleize(`${place.display}, ${place.city_name}`);
}

export function formatOnlyTerminalDisplay(place) {
  return titleize(place.display);
}

export function formatDisplayType(displayType, place, isPackagesSearch, lang) {
  switch (displayType) {
    case 'city':
    case 'city_state':
      return formatCityDisplay(isPackagesSearch, place, lang);

    case 'terminal_city':
      return formatTerminalCityDisplay(place);

    case 'state':
      return formatStateDisplay(place);

    case 'only_terminal':
      return formatOnlyTerminalDisplay(place);

    default:
      return formatStateDisplay(place);
  }
}

export function formatRecommendedDisplayType(place, displayType) {
  const formatted = formatDisplayType(displayType, place, false);
  return place.city_name ? (
    <Fragment>
      {formatted.split(',')[0]} <span>{formatted.split(',')[1]?.trim()}</span>
    </Fragment>
  ) : (
    <Fragment>{place.name}</Fragment>
  );
}

export const createPlace = place => ({
  city_name: place.cityName,
  display: place.display,
  state: place.state,
});
